import { AuthChallenge } from '../data/AuthChallenge';
import { AuthChallengeParser } from './AuthChallengeParser';
import * as setCookieParser from 'set-cookie-parser';
import { HeadersJson } from '../data/AuthTypes';
import { Cookie } from '../data/AuthTypes';
import { headerConstants } from '../../../auth/AuthConstants';

export class HeaderParser {
	private static instance: HeaderParser;

	public static getInstance(): HeaderParser {
		if (!HeaderParser.instance) {
			HeaderParser.instance = new HeaderParser();
		}
		return HeaderParser.instance;
	}

	parseAuthHeader(headers: HeadersJson): AuthChallenge {
		const authChallengeHeader = this.extractHeaderValue(
			headers,
			headerConstants.AUTHENTICATE_HEADER
		);
		return AuthChallengeParser.getInstance().parse(authChallengeHeader);
	}

	parseCookieHeader(headers: HeadersJson): Cookie[] {
		const cookieHeaderValue = this.extractHeaderValue(
			headers,
			headerConstants.SET_COOKIE_HEADER
		);
		if (cookieHeaderValue) {
			const unparsedCookies: string[] =
				setCookieParser.splitCookiesString(cookieHeaderValue);
			const cookies: Cookie[] = setCookieParser.parse(unparsedCookies, {
				decodeValues: false, // default: true
			});
			for (const cookie of cookies) {
				if (cookie.name) cookie.name = cookie.name.trim();

				if (cookie.domain && cookie.domain[0] === '.') {
					cookie.domain = cookie.domain.substring(1);
				}

				if (!(cookie.maxAge === null || typeof cookie.maxAge === 'undefined'))
					cookie.cookieExpiryMillis = Date.now() + cookie.maxAge * 1000;
				else if (cookie.expires) cookie.cookieExpiryMillis = cookie.expires.getTime();
			}
			return cookies;
		} else {
			return null;
		}
	}

	parseAuthDomainHeader(headers: HeadersJson): string {
		return this.extractHeaderValue(headers, headerConstants.AUTH_DOMAIN_HEADER);
	}

	extractHeaderValue(headers: HeadersJson, headerKey: string): string {
		if (headers) {
			for (const key in headers) {
				if (key.toLowerCase() === headerKey.toLowerCase()) {
					return headers[key];
				}
			}
		}
	}

	containsMediaTypeinContentType(headers: HeadersJson, inputMediaType: string): boolean {

		const contentType = this.extractHeaderValue(headers, headerConstants.CONTENT_TYPE);
		if (contentType) {
			const mediaTypes = contentType.split(';');
			for (const mediaType of mediaTypes) {
				const resultString = mediaType.replace(/0+$/, '');
				if (resultString.trim().toLowerCase() == inputMediaType) {
					return true;
				}
			}
		}
		return false;
	}
}
